module.exports = __webpack_public_path__ + "static/img/beijing.4dce657.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beijing.jpg
// module id = xsOF
// module chunks = 1